import { Injectable } from '@angular/core';
import { IndividualAccountStaging } from '../models/individual-account/individual-account-staging';
import { AuthService } from '../services';
import { ApiClientService } from './common/api-client.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndividualAccountService {

  constructor(private apiClient: ApiClientService,
    private authService: AuthService)
  {

  }

  createSubscription(objStaging: IndividualAccountStaging) {
    return this.apiClient.post('api/individualpayment/createSubscription', objStaging, null, false);
  }

  finalizeSubscription(req: any) {
    return this.apiClient.post('api/individualpayment/finalizeSubscription', req, null, false);
  }

  validateCoupon(req: any) {
    return this.apiClient.post('api/individualpayment/validateCoupon', req, null, true);
  }

  cleanup(req: any) {
    return this.apiClient.post('api/individualpayment/cleanupSubscription', req, null, false);
  }

  createIndividualAccountStaging(objStaging: IndividualAccountStaging) {
    return this.apiClient.post('api/IndividualLogin/insertIndividualAccountStaging', objStaging, null, true);
  }

  verifyIndividualAccountStaging(objStaging: IndividualAccountStaging) {
    return this.apiClient.post('api/IndividualLogin/VerifyIndividualAccountStaging', objStaging, null, true);
  }

  getIndividualAccountStaging(individualAccountStagingId: number) {
    return this.apiClient.get(`api/individualpayment/getIndividualAccountStaging/${individualAccountStagingId}`, null, null, false);
  }

  getIndividualAccountPlans() {
    return this.apiClient.get('api/individualpayment/getIndividualAccountPlans', null, true);
  }

  getProductPrice(individualAccountPlanId: number) {
    return this.apiClient.get(`api/individualpayment/getProductPrice/${individualAccountPlanId}`, null, true);
  }

  getIndividualUserDetails(individualUserId: number) {
    return this.apiClient.get(`api/individualpayment/getIndividualUserDetails/${individualUserId}`, null, null, false);
  }

  verifyIndividualUserNPN(objStaging: IndividualAccountStaging) {
    return this.apiClient.post('api/individualpayment/VerifyIndividualUserNPN', objStaging, null, true);
  }


  getDownloadReceiptUrl(chargeId: string) {
    return this.apiClient.get(`api/individualpayment/downloadReceipt/${chargeId}`);
  }

  createIndividualAccountPaymentRequest(listNewLicenseRequest: any) {
    return this.apiClient.post('api/individualrequest/createNewLicenseRequest', listNewLicenseRequest, null, true);
  }

  processNewLicenseRequest(individualPaymentRequestId: number) {
    return this.apiClient.post(`api/individualrequest/processNewLicenseRequest/${individualPaymentRequestId}`, null, null, false);
  }

  getRequestStatus(individualPaymentRequestId: number) {
    return this.apiClient.post(`api/individualrequest/getRequestStatus/${individualPaymentRequestId}`, null, null, false);
  }

  getIndividualUserPaymentInfo(individualUserId: number) {
    return this.apiClient.get(`api/IndividualLogin/getIndividualUserPaymentInfo/${individualUserId}`, null, null, true);
  }

  cancelSubscription(requestObject: any) {
    return this.apiClient.post(`api/IndividualPayment/cancelIndividualSubscription`, requestObject, null, true);
  }

  reactivateSubscription() {
    return this.apiClient.post(`api/IndividualPayment/reactivateIndividualSubscription`, null, null, true);
  }

  getCardByRequestId(individualPaymentRequestId: number) {
    return this.apiClient.post(`api/individualrequest/getCardByRequestId/${individualPaymentRequestId}`, null, null, true);
  }

  createBulkRenewalRequest(listNewLicenseRequest: any) {
    return this.apiClient.post('api/individualrequest/createBulkRenewalRequest', listNewLicenseRequest, null, true);
  }

  processBulkRenewalRequest(individualPaymentRequestId: number) {
    return this.apiClient.post(`api/individualrequest/processBulkRenewalRequest/${individualPaymentRequestId}`, null, null, false);
  }

  getRequestChargeId(requestId: number) {
    return this.apiClient.post(`api/individualrequest/getRequestChargeId/${requestId}`, null, null, false);
  }

  getCustomerPayments(): Observable<any[]> {
    return this.apiClient.get(`api/IndividualPayment/GetCustomerPayments`);
  }

  getDownloadReceiptUrlByRequestId(requestId: number) {
    return this.apiClient.post(`api/individualrequest/getDownloadReceiptUrlByRequestId/${requestId}`, null, null, false);
  }

  updateIndividualCardInfo(individualPaymentInfo: any){
    return this.apiClient.put('api/IndividualPayment/updateIndividualCardInfo', individualPaymentInfo, null, true);
  }

  getLastFailedInvoiceDetails(individualUserId: number) {
    return this.apiClient.get(`api/IndividualPayment/getLastFailedInvoiceDetails/${individualUserId}`, null, null, true);
  }

  createPaymentRequestForFailedInvoice(individualUserId: number) {
    return this.apiClient.post(`api/IndividualPayment/createPaymentRequestForFailedInvoice/${individualUserId}`, null, null, false);
  }
  getTandCForIndividualUser(individualStagingId: number) {
    return this.apiClient.get(`api/IndividualLogin/getTandCForIndividualUser/${individualStagingId}`, null, null, true);   
  }
  insertTandCAcceptanceDetails(individualStagingId: number) {
    return this.apiClient.post(`api/IndividualLogin/insertIndividualTandCAcceptanceDetails/${individualStagingId}`, null, null);
  }

  getIndividualAccountCancelationReasons() {
    return this.apiClient.get(`api/IndividualPayment/getIndividualAccountCancelationReasons`, null, null, true);   
  }
}
